import script from "./ExamDashboardChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamDashboardChart.vue?vue&type=script&setup=true&lang=ts"

import "./ExamDashboardChart.vue?vue&type=style&index=0&id=418bb805&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418bb805"]])

export default __exports__